export const environment = {
    production: false,
    apiUrlBase: 'https://api-dev.plumap.com/api/',
    // Laravel Reverb (self-hosted WebSocket, tablet sign-request pushes).
    // Reuses api-dev.plumap.com (no separate ws subdomain/DNS record) - see
    // environment.prod.ts's comment / erp-backend's docker-compose-dev.yml.
    // wsKey MUST match REVERB_APP_KEY_DEV set in erp-backend's dev-server .env -
    // there is no shared source between the two repos, keep them in sync by hand.
    wsHost: 'api-dev.plumap.com',
    wsPort: 443,
    wsScheme: 'https' as 'http' | 'https',
    wsKey: 'reverbkey471520',
    allowLocalStores: false,
}